const ROUTES = (product = "personal-loan") => ({
  E_SIGN_INSTRUCTIONS: `/${product}/e-sign/instructions`,
  LOAN_DISBUSRED: `/${product}/conditional-approval`,
});
export default ROUTES;